
export default {
  draft: {
    label: 'Rascunho',
    description: 'Não está pronto para publicar.'
  },
  pending: {
    label: 'Pendente',
    description: 'Aguardando revisão antes de publicar.'
  },
  private: {
    label: 'Privado',
    description: 'Visível apenas para administradores e editores.'
  },
  scheduled: {
    label: 'Agendado',
    description: 'Publicar automaticamente na data escolhida.'
  },
  published: {
    label: 'Publicado',
    description: 'Visível para todos.'
  } ,
  options:{
    draft: 'Rascunho',
    pending: 'Pendente',
    private: 'Privado',
    scheduled: 'Agendado',
    published: 'Publicado'
  }
}